<template>
    <div class="container">
        <div class="row">
            <div class="col">
                <h2 class="section-title">IMPRESSIONEN</h2>
            </div>
        </div>
        <div class="row justify-content-center justify-content-lg-start">
            <impression v-for="(impression, idx) in impressions"
                        :key="idx"
                        @open-gallery="openGallery"
                        :class="classForIndex(idx)"
                        :index="idx"
                        :impression="impression"
                        :visible="idx < limit"/>
        </div>
        <div class="row justify-content-center pb-5" v-if="limit < impressions.length">
            <button type="button" @click="more()" class="btn btn-more">
                <span>mehr Impressionen laden</span>
            </button>
        </div>
        <lightbox v-if="currentIdx != null"
                  @close="currentIdx = null"
                  :images="imageUrls"
                  :index="currentIdx"/>
    </div>
</template>

<script>
    import Impression from "./Impression";
    import Lightbox from "./Lightbox";

    export default {
        name: "Impressions",
        props: ['impressions'],
        components: {Lightbox, Impression},
        data() {
            return {
                limit: 6,
                currentIdx: null
            }
        },
        computed: {
            imageUrls() {
                return this.impressions.map(i => i.url);
            }
        },
        methods: {
            openGallery(data) {
                console.log(data);
                this.currentIdx = data;
            },
            more() {
                this.limit += 6
            },
            classForIndex(idx) {
                let classes = 'col-12 col-sm-auto col-lg-4';
                if (idx < this.limit) {
                    return classes;
                }

                return classes + ' d-none';
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/js/components/Impressions.vue